module.exports = __webpack_public_path__ + "90fd6ae4c6e38035a0c44be09824008c.svg";